import React, { useContext, useEffect, useState } from 'react'
import SearchTable from 'src/components/searchTable'
import { checkPermissions } from 'src/views/utils/helper'
import ArtistTypeCreateModal from './artistTypeCreateModal'
import { CFormSwitch } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import { GlobalContext } from '../../../context/GlobalState'
import { PERMISSIONS } from '../../../utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import { ARTIST_TYPE_LIST_API } from '../../../utils/urls'
import { raiseToast } from '../../../utils/helper'
import { AppContext } from '../../../context/app'

const ArtistsTypes = () => {
  const { setLoader, accountObj } = useContext(AppContext)
  const [selectedArtist, setSelectedArtist] = useState({})
  const language = localStorage.getItem('language')
  const [openModal, setOpenModal] = useState(false)

  const { userSessionObj } = useContext(GlobalContext)
  const defaultLangCheck = language === accountObj?.default_language
  const isCreateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.ARTIST.CREATE) &&
    defaultLangCheck

  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.ARTIST.UPDATE,
  )

  const [{ data: artistTypeList, loading: artistTypeLoading }, artistTypeCall] = useAxios(
    {
      url: ARTIST_TYPE_LIST_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createArtistType, loading: createArtistTypeLoading }, artistTypeCreateCall] =
    useAxios(
      {
        url: ARTIST_TYPE_LIST_API,
        method: 'post',
      },
      { manual: true },
    )

  const [{ data: updateArtistType, loading: updateArtistTypeLoading }, artistTypeUpdateCall] =
    useAxios(
      {
        url: ARTIST_TYPE_LIST_API,
        method: 'put',
      },
      { manual: true },
    )

  useEffect(() => {
    artistTypeCall()
  }, [])

  useEffect(() => {
    setLoader(artistTypeLoading || createArtistTypeLoading || updateArtistTypeLoading)
  }, [artistTypeLoading, createArtistTypeLoading, updateArtistTypeLoading])

  useEffect(() => {
    if (createArtistType && createArtistType.success) {
      artistTypeCall()
      raiseToast('success', 'Artist type created successfully')
    }
  }, [createArtistType])

  useEffect(() => {
    if (updateArtistType && updateArtistType.success) {
      artistTypeCall()
      raiseToast('success', 'Artist type updated successfully')
    }
  }, [updateArtistType])

  const handleStatus = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    editArtistType({ status: !info.status }, info._id)
  }

  const addArtistType = (payload) => {
    artistTypeCreateCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editArtistType = (payload, id) => {
    artistTypeUpdateCall({
      params: {
        artist_type_id: id,
      },
      data: payload,
    })
    setOpenModal(false)
  }

  const handleEdit = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedArtist(info)
    setOpenModal(true)
  }

  const handleAdd = () => {
    if (!isCreateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedArtist({})
    setOpenModal(!openModal)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 22,
    },
    {
      header: 'Description',
      dataCell: (info) => info.description,
      width: 33,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 15,
    },
    {
      header: 'Status',
      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 18,
    },

    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 7,
    },
  ]
  return (
    <>
      <h4>Artists types</h4>
      <p>{`Manage your Artists types`}</p>
      <SearchTable
        type={`Artist Type`}
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ Add`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableContent={artistTypeList && artistTypeList.data}
        tableConfig={tableConfig}
        createPermission={isCreateAllowed}
        disabledButtonTitle={
          defaultLangCheck ? '' : 'Adding Artist Type Available on Default Language'
        }
      />

      {openModal && (
        <ArtistTypeCreateModal
          data={selectedArtist}
          openModal={openModal}
          onCancel={() => {
            setOpenModal(false)
            setSelectedArtist({})
          }}
          setOpenModal={setOpenModal}
          addCallback={addArtistType}
          updateCallback={editArtistType}
        />
      )}
    </>
  )
}

export default ArtistsTypes
